import PropTypes from 'prop-types';

export const Props = {
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
